module.exports = __webpack_public_path__ + "img/icon_arrow.9a271a6d.svg";